import React, { lazy, Suspense, memo } from 'react'
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Loading from 'components/shared-components/Loading';
import { lightTheme, darkTheme } from 'configs/ThemeConfig';
import { resources } from 'lang';
import useBodyClass from 'utils/hooks/useBodyClass';
import Routes from 'routes'
import Cookies from 'js-cookie';
import { decodeAuth } from 'utils/Helper';

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {
	// Re-read session cookie after soft login/logout navigations (no full reload).
	useLocation();

	const blankLayout = useSelector(state => state.theme.blankLayout);
	const getAuth = Cookies.get('vb\C#^*gW589');
	const dcode = getAuth ? decodeAuth(getAuth): null;
	const Layout = getAuth && !blankLayout ? (!dcode?.user?.is_password_changed ? AuthLayout: AppLayout) : AuthLayout;

	const locale = useSelector(state => state.theme.locale);

	const direction = useSelector(state => state.theme.direction);

	const currentTheme = useSelector(state => state.theme.currentTheme);

	const currentAppLocale = resources[locale];

	useBodyClass(`dir-${direction}`);

	const themeConfig = currentTheme === 'light' ? {...lightTheme} : {...darkTheme}

	return (
		<ConfigProvider theme={themeConfig} direction={direction} locale={currentAppLocale.antd}>
			<Suspense fallback={<Loading cover="content"/>}>
				<Layout>
					<Routes />
				</Layout>
			</Suspense>
		</ConfigProvider>
	)
}

export default memo(Layouts)